// COLORS
export var COLORS = {
  white: '#FFF',
  black: '#000'
};

export var MATERIAL_COLORS = {
  500: {
    amber: '#FFC107',
    blue_grey: '#607D8B',
    blue: '#2196F3',
    brown: '#795548',
    cyan: '#00BCD4',
    deep_orange: '#FF5722',
    deep_purple: '#673AB7',
    green: '#4CAF50',
    grey: '#9E9E9E',
    indigo: '#3F51B5',
    light_blue: '#03A9F4',
    light_green: '#8BC34A',
    lime: '#CDDC39',
    orange: '#FF9800',
    pink: '#E91E63',
    purple: '#9C27B0',
    red: '#F44336',
    teal: '#009688',
    yellow: '#FFEB3B'
  }
};

export var PRIMARY_COLOR = {
  main: '#28292D',
  alt: '#2E2F33',
  icon: '#e8e8e8',
  border: '1px solid #555',
  text_main: COLORS.white,
  text_alt: '#EBEBEB',
  input: '#55595C'
};

export var SECONDARY_COLOR = {
  main: '#1CA6FC',
  alt: '#005FAF',
  icon: '#77cbff',
  border: '1px solid #FFF'
};

export var MESH_SELECTED = '#99C3FB';

export var AREA_MESH_COLOR = {
  selected: MESH_SELECTED,
  unselected: '#FFF'
};

export var PIPE_MESH_COLOR = {
  selected: "#000000",
  unselected: '#777777'
};

export var LINE_MESH_COLOR = {
  selected: "#000000",
  unselected: '#777777'
};

export var CONTROL_POINT_STYLE = {
  fill: "rgba(0, 150, 253, 1)",
  cursor: "all-scroll",
  stroke: "rgba(0, 150, 253, 1)"
};

export var CONTROL_POINT_ARROW_STYLE = {
  fill: "white",
  // stroke: "white",
  cursor: "all-scroll"
  // strokeWidth: "0.5"
};

export var CONTROL_POINT_RADIUS = 8;
export var CONTROL_POINT_RADIUS_BIG = 20;